import { inject, Injectable } from '@angular/core';
import { PackageRepository } from '../../../@core/repositories/package.repository';
import { Observable } from 'rxjs';
import { GetPackageDto, GetPackageResp } from '../../../@core/usecase/package/get-package/get-package.interface';
import { environment } from '@environments/environment';
import { GetCategoryHaloPackageResp } from '@usecase/package/get-category-halo-package/get-category-halo-package.type';
import { GetHaloPackageDto, GetHaloPackageResp } from '@usecase/package/get-halo-package/get-halo-package.type';
import { PromoType } from '@data/domain/promo.entity';
import { HttpService } from '@shared/services/http/http.service';
import { GetPackageDetailDto, GetPackageDetailResp } from '@usecase/package/get-package-detail/get-package-detail.type';

@Injectable({
    providedIn: 'root'
})

export class PackageAdapter extends PackageRepository {
    private readonly httpService = inject(HttpService);

    GetPackageList(params: GetPackageDto, promoType: PromoType): Observable<GetPackageResp> {
        return this.httpService.post(`${environment.serviceApi}package/${promoType === 'promo' ? 'promo' : 'promo/btl'}`, params);
    }

    GetCategoryHaloPackage(): Observable<GetCategoryHaloPackageResp> {
        return this.httpService.get(`${environment.serviceApi}package/offer/halo/category`, {});
    }

    GetHaloPackage(payload: GetHaloPackageDto): Observable<GetHaloPackageResp> {
        return this.httpService.post(`${environment.serviceApi}v2/package/halo-plus`, payload);
    }

    GetPackageDetail(payload: GetPackageDetailDto): Observable<GetPackageDetailResp> {
        return this.httpService.post(`${environment.serviceApi}package`, payload);
    }
}